export default __webpack_public_path__ + "static/media/image-team-members.c2c1e827.jpg";